import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const forgeServicedeskQueueRoute: InvariantJiraRoute = {
	name: 'forge-spa-servicedesk-queue',
	path: '/jira/servicedesk/projects/:projectKey/queues/apps/:appId/:envId/:route?',
};
